module.exports = __webpack_public_path__ + "static/media/24UHCHR14.1a2feaa0.jpg";